import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const NAV_OFFSET = 72;

/**
 * Resets scroll on navigation. When the target URL carries a hash — every CTA
 * on the page points at `#contact`, `#advantage` or `#engineering` — scroll to
 * that section instead, offset by the sticky nav.
 */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    // `scroll-behavior: smooth` is set globally for in-page anchors; a route
    // change should still jump straight to the top.
    if (!hash) {
      window.scrollTo({ top: 0, behavior: 'instant' as ScrollBehavior });
      return;
    }

    // The target section may not be mounted yet on a cross-page jump.
    const frame = requestAnimationFrame(() => {
      const target = document.getElementById(hash.slice(1));
      if (!target) {
        window.scrollTo({ top: 0, behavior: 'instant' as ScrollBehavior });
        return;
      }
      const top = target.getBoundingClientRect().top + window.scrollY - NAV_OFFSET;
      window.scrollTo({ top, behavior: 'smooth' });
    });

    return () => cancelAnimationFrame(frame);
  }, [pathname, hash]);

  return null;
}
